<template>
  <div>
    <h4 class="my-4">{{ title }}</h4>
    <div
      v-for="(questionData, index) in allQuestions"
      :key="index"
      class="editable-question"
    >
      <div class="top">
        <inline-svg
          :src="require('@/assets/svg/question-template-icon.svg')"
          class="mr-2"
        />
        <div class="d-flex flex-column flex-grow-1">
          <div class="font-weight-bold">
            {{ questionData.question }}
          </div>
          <div>
            {{ questionData.explanation }}
          </div>
        </div>
      </div>
      <v-divider class="mt-5 mb-0" />
      <div class="bottom">
        <ErrorButton
          @click.native="handleRemove(questionData, index)"
          :loading="isRemoving"
          light
          class="align-center"
        >
          Remove
        </ErrorButton>
      </div>
    </div>
    <AddApplicationQuestionAction @onAdd="handleAdd" :title="title" />
  </div>
</template>

<script>
import AddApplicationQuestionAction from "./actions/AddApplicationQuestionAction";
import InlineSvg from "vue-inline-svg";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { includes, filter, map } from "lodash";
import {
  REMOVE_BOOKING_APPLICATION_QUESTION,
  ADD_BOOKING_APPLICATION_QUESTION
} from "@/store/modules/applications/actions";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(APPLICATION_NAMESPACE);

export default {
  data() {
    return {
      isRemoving: false,
      allQuestions: [...this.existingQuestions],
      questionsToRemove: [],
      questionsToAdd: []
    };
  },
  props: {
    title: { type: String, required: true },
    existingQuestions: Array
  },
  components: {
    AddApplicationQuestionAction,
    InlineSvg,
    ErrorButton
  },
  computed: {
    currentBookingId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      addBookingApplicationQuestion: ADD_BOOKING_APPLICATION_QUESTION,
      removeBookingApplicationQuestion: REMOVE_BOOKING_APPLICATION_QUESTION
    }),
    handleRemove(question, index) {
      if (includes(this.questionsToAdd, { id: question.id })) {
        this.questionsToAdd = filter(this.questionsToAdd, { id: question.id });
      } else {
        this.questionsToRemove.push(question);
      }
      this.allQuestions.splice(index, 1);
    },
    handleAdd(question) {
      this.questionsToAdd.push(question);
      this.allQuestions.push(question);
    },
    removeQuestions() {
      const requests = map(this.questionsToRemove, ({ id }) =>
        this.removeBookingApplicationQuestion(id)
      );
      return Promise.all(requests);
    },
    addQuestions() {
      const requests = map(this.questionsToAdd, questionData => {
        const {
          options,
          inputType,
          characterLimit,
          explanation,
          required,
          question
        } = questionData;
        return this.addBookingApplicationQuestion({
          optionsTemplate: map(options, ({ validResponse, option }) => ({
            validResponse,
            option
          })),
          inputType,
          characterLimit,
          explanation,
          required,
          question,
          booking: {
            id: this.currentBookingId
          }
        });
      });
      return Promise.all(requests);
    },
    async handleSubmit() {
      await this.removeQuestions();
      await this.addQuestions();
    }
  }
};
</script>
<style lang="scss">
.editable-question {
  border: 2px solid $default-line;
  border-radius: 4px;
  margin-bottom: 20px;

  .top {
    display: flex;
    padding: 15px 15px 0 15px;
  }
  .bottom {
    display: flex;
    justify-content: flex-end;
    padding: 15px;
  }
}
</style>
